/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-10-26 15:25:41
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

import { lazy } from 'react';
import { RouterConfig } from '../../types';

const amiFunctionRouterConfig: RouterConfig[] = [
    {
        key: 'AMI Function',
        title: 'menuTitleAmiFunction',
        icon: 'AMIMenuSVG',
        subs: [
            {
                key: 'Connect and Disconnect',
                title: 'menuTitleConnectAndDisconnect',
                route: '/home/amiFunction/connectAndDisconnect',
                component: lazy(() => import('src/pages/amiFunction/connectAndDisconnect')),
            },
            {
                key: 'Task Mgnt',
                title: 'menuTitleTaskManagement',
                route: '/home/amiFunction/taskManagement',
                component: lazy(() => import('src/pages/amiFunction/taskManagement')),
            },
            {
                key: 'Firmware Upgrade',
                title: 'menuTitleFirmwareUpgrade',
                route: '/home/amiFunction/firmwareUpgrade',
                component: lazy(() => import('src/pages/amiFunction/firmwareUpgrade')),
            },
            {
                key: 'Device Monitoring',
                title: 'menuTitleDeviceMonitoring',
                route: '/home/amiFunction/deviceMonitoring',
                component: lazy(() => import('src/pages/amiFunction/deviceMonitoring')),
            },
            {
                key: 'Network Mgnt',
                title: 'menuTitleNetworkManagement',
                route: '/home/amiFunction/networkManagement',
                component: lazy(() => import('src/pages/amiFunction/networkManagement')),
            },
            {
                key: 'On-Demand Reading',
                title: 'menuTitleOnDemandReading',
                route: '/home/amiFunction/onDemandReading',
                component: lazy(() => import('src/pages/amiFunction/onDemandReading/index')),
            },
            {
                key: 'Abnormal Mgnt',
                title: 'tabTitleScheduleReading',
                route: '/home/amiFunction/abnormalManagement',
                component: lazy(() => import('src/pages/amiFunction/abnormalManagement')),
            },
            {
                key: 'Meter Reading Success Rate',
                title: 'menTitleScheduleReadingStastics',
                route: '/home/amiFunction/meterReadingSuccessRate',
                component: lazy(() => import('src/pages/amiFunction/meterReadingSuccessRate')),
            },
            {
                key: 'Meter Param',
                title: 'menuTitleMeterParam',
                route: '/home/amiFunction/meterParam',
                component: lazy(() => import('src/pages/amiFunction/meterParam')),
            },
            {
                key: 'Meter Key Mgnt',
                title: 'menuTitleMeterKeyMgnt',
                route: '/home/amiFunction/meterKeyMgnt',
                component: lazy(() => import('src/pages/amiFunction/meterKeyMgnt')),
            },
            {
                key: 'Key Mgnt',
                title: 'menuTitleKeyMgnt',
                route: '/home/amiFunction/KeyMgnt',
                component: lazy(() => import('src/pages/amiFunction/keyMgnt')),
            },
            {
                key: 'SNMP Mgnt',
                title: 'menuTitleSNMPMngt',
                route: '/home/amiFunction/snmpMgnt',
                component: lazy(() => import('src/pages/amiFunction/deviceMgnt/index')),
            },
            {
                key: 'VEE',
                route: '/home/amiFunction/VEE',
                title: 'menuTitleAbnormalLoadProfileDataQuery',
                component: lazy(() => import('src/pages/amiFunction/vee')),
            },
        ],
    },
];

export default amiFunctionRouterConfig;
